import React from "react";
import "./chatuser.css";

// Renders a user chat bubble with an optional attached image above the text.
function chatuser(props) {
return (
  <div className="krunk-chat1" style={{ marginTop: '8px', paddingTop: '0', paddingBottom: '0' }}>
    <div
      className="krunk-bg-bubblecolor krunk-text-textcolor"
      style={{
        maxWidth: '250px',
        padding: '0 7px',
        borderRadius: '8px 0 8px 8px',
        border: '1px solid #fff',
      }}>
      {props.message.image_url && (
        <a href={props.message.image_url} target="_blank" rel="noopener noreferrer">
          <img
            src={props.message.image_url}
            alt="Sent by you"
            style={{ display: 'block', maxWidth: '100%', maxHeight: '200px', borderRadius: '6px', margin: '7px 0' }}
          />
        </a>
      )}
      {props.message.text && (
        <p style={{ paddingTop: '0', paddingBottom: '0', margin: '10px 0' }}>{props.message.text}</p>
      )}
    </div>
  </div>
);
}

export default chatuser;
